module.exports = __webpack_public_path__ + "static/img/0201_01.39c0ece.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sub/02/0201_01.jpg
// module id = tOT2
// module chunks = 1